module.exports = __webpack_public_path__ + "img/desirability.f86e5105.svg";